import React, { useEffect, useMemo } from 'react'
import { ScrollView, Text, View } from 'react-native'
import { useCssStyle } from '../../customHook/getCssStyle';
import HeaderWithBack from '../../components/Header/headerWithBack';
import { ImageComp } from '../../components/Image/Image';
import { getCleanUrl } from '../../utils/Helper';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setRenderFlashMessage } from '../../Redux/Actions/appConfigAction';
import { CustomTextInput } from '../../components/customTextInput';
import CustomPressable from '../../components/customPressable/customPressable';
import { HEART } from '../../assets';

const SpaBooking2c = (props) => {
    const { currentWidget, bookingObj, updateBookingObj, handleNext, handleGoBack } = props;

    const getStyles = useCssStyle();
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { currentGuestDetails } = useSelector(state => state.guestDetailsSlice);
    const guestDetails = useMemo(
        () => ({
            email: currentGuestDetails?.guestProfile?.email,
            phone: currentGuestDetails?.guestProfile?.phone
        }),
        [currentGuestDetails]
    );

    const handleGoNext = () => {
        let emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        if (!(bookingObj?.isAnyPrevReservForAnyLocation || bookingObj?.updateReservationDetails)) {

            if (bookingObj?.additionalDetails?.mobileNumber == "") {
                dispatch(setRenderFlashMessage(true, {type: "danger", message: t('spaBooking.enter_mobileNumber')}))
                return;
            }

            if (bookingObj?.additionalDetails?.email == "") {
                dispatch(setRenderFlashMessage(true, {type: "danger", message: t('spaBooking.enter_email')}))
                return;
            }

            if (!emailRegex.test(bookingObj?.additionalDetails?.email)) {
                dispatch(setRenderFlashMessage(true, {type: "danger", message: "Please enter a valid email"}))
                return;
            }
        }

        handleNext()
    }

    useEffect(() => {
        if(guestDetails?.email && !bookingObj?.additionalDetails?.email){
            updateBookingObj({
                additionalDetails: {
                    ...bookingObj?.additionalDetails,
                    email: guestDetails?.email
                }
            })
        }

        if(guestDetails?.phone && !bookingObj?.additionalDetails?.email){
            updateBookingObj({
                additionalDetails: {
                    ...bookingObj?.additionalDetails,
                    email: guestDetails?.phone
                }
            })
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [guestDetails])


    return (
        <View style={getStyles(['widgetRootContainer', 'spaBookingRootContainer'])} id='spaBookingRootContainer'>
            <HeaderWithBack handleCustomBackPress={handleGoBack} />
            
            <ScrollView
                automaticallyAdjustKeyboardInsets={true} 
                contentContainerStyle={getStyles(['widgetmainContainer', 'spaBookingMainContainer'])} 
                showsVerticalScrollIndicator={false}
                id='spaBookingMainContainer'
            >
                <View style={getStyles(['widgetmainContainerHeaderContainer', 'spaBookingHeaderContainer'])} id='spaBookingHeaderContainer'>
                    {currentWidget?.widgetHeaderImageUrl && 
                        <ImageComp
                            source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} 
                            style={getStyles(['widgetmainContainerHeaderImg', 'spaBookingHeaderImg'])} id={"spaBookingHeaderImg"}
                        />
                    }
                    <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'spaBookingHeaderTitleContainer'])} id='spaBookingHeaderTitleContainer'>
                        <ImageComp source={HEART} style={getStyles(["spaBookingHeaderTitleImage"])} id="spaBookingHeaderTitleImage"/>

                        <Text style={getStyles(['widgetmainContainerHeaderTitle', 'spaBookingHeaderTitle'])} id='spaBookingHeaderTitle'>
                            {t(`spaBooking.additional_details.heading`)}
                        </Text>

                        <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'spaBookingHeaderSubTitle'])} id='spaBookingHeaderSubTitle'>
                            {t("spaBooking.additional_details.subheading")}
                        </Text>
                        <View style={getStyles(["horizontalline"])} id='horizontalline'></View>
                    </View>
                </View>


                <View style={getStyles(['widgetmainContainerChildContainer', 'spaBookingMainContainerChildContainer'])} id='spaBookingMainContainerChildContainer'>

                    <View style={getStyles(["spaBooking2cInputContainer"])} id='spaBooking2cInputContainer'>
                        {!(bookingObj?.isAnyPrevReservForAnyLocation || bookingObj?.updateReservationDetails) &&
                            <View style={getStyles(["textContainer"])}>
                                <Text style={getStyles(["label"])}>
                                    {t('spaBooking.phone_number')} <Text style={{ color: "red" }}>*</Text>
                                </Text>

                                <CustomTextInput
                                    value={bookingObj?.additionalDetails.mobileNumber}
                                    onChangeText={(value) => {
                                        updateBookingObj({
                                            additionalDetails: {
                                                ...bookingObj?.additionalDetails, 
                                                mobileNumber: value
                                            }
                                        })
                                    }}
                                    placeholder={t('spaBooking.mobileNumber_placeholder')}
                                    maxLength={15}
                                />
                            </View>}

                        {!(bookingObj?.isAnyPrevReservForAnyLocation || bookingObj?.updateReservationDetails) &&
                            <View style={getStyles(["textContainer"])}>
                                <Text style={getStyles(["label"])}>
                                    {t('spaBooking.email')} <Text style={{ color: "red" }}>*</Text>
                                </Text>

                                <CustomTextInput
                                    value={bookingObj?.additionalDetails.email}
                                    onChangeText={(value) => {
                                        updateBookingObj({
                                            additionalDetails: {
                                                ...bookingObj?.additionalDetails,
                                                email: value
                                            }
                                        })
                                    }}
                                    placeholder={t('spaBooking.email_placeholder')}
                                />
                            </View>}
                        

                        <View style={getStyles(["textContainer"])}>
                            <Text style={getStyles(["label"])}>
                                {t('spaBooking.guestNotes')}
                            </Text>

                            <CustomTextInput
                                value={bookingObj?.additionalDetails.guestNotes}
                                onChangeText={(value) => {
                                    updateBookingObj({
                                        additionalDetails: {
                                            ...bookingObj?.additionalDetails,
                                            guestNotes: value
                                        }
                                    })
                                }}
                                placeholder={t('spaBooking.guestNotes_placeholder')}
                            />
                        </View>
                    </View>

                </View>
            </ScrollView>

            <View id='spaBookingNextButtonContainer' style={getStyles(['spaBookingNextButtonContainer'])}>
                <CustomPressable
                    style={getStyles(['primaryBtn'])} 
                    onPress={() => handleGoNext()} 
                    id="primaryBtn"
                >
                    <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>
                        {t("spaBooking.continue")}
                    </Text>
                </CustomPressable>

                {/* <CustomPressable style={getStyles(['secondaryBtn'])} onPress={handleGoBack}>
                    <Text style={getStyles(['secondaryBtnTxt'])}>{t('spaBooking.back')}</Text>
                </CustomPressable> */}
            </View>
        </View>
    )
}

export default SpaBooking2c
